import { render, staticRenderFns } from "./DispatchCustomer.vue?vue&type=template&id=d99ce87e&scoped=true"
import script from "./DispatchCustomer.vue?vue&type=script&lang=js"
export * from "./DispatchCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99ce87e",
  null
  
)

export default component.exports